import React, { useState ,useEffect} from 'react';
import { ChevronDown, Menu, X, CreditCard, Smartphone, Globe, Users, TrendingUp, Shield, Zap, CheckCircle, Star,
  ArrowRight, Clock, Wifi, Lock, Building2,MousePointer,ArrowLeftRight, Activity, BarChart3, Bell,
  Video, Eye, Settings, Database, Cpu, FileText,Play,Mail,BarChart,ShoppingCart,ChartBar
} from 'lucide-react';
import CompanyLogosMarquee from './companies';
import Header from './header'
import Footer from './footer'
 
// Reusable Card Section Component
const CardSection = ({ title, cards, showCTA = true }) => (
  <section className="py-20 bg-gradient-to-br from-gray-50 via-blue-50/30 to-purple-50/20 relative overflow-hidden">
    {/* Background decorations */}
    <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-r from-blue-600/3 to-purple-600/3"></div>
    <div className="absolute top-32 left-20 w-64 h-64 bg-blue-300/20 rounded-full blur-3xl animate-pulse"></div>
    <div className="absolute bottom-32 right-20 w-80 h-80 bg-purple-300/20 rounded-full blur-3xl animate-pulse" style={{animationDelay: '2s'}}></div>
    
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
      {title && (
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">{title}</h2>
        </div>
      )}
      
      <div className="grid lg:grid-cols-2 gap-12 items-stretch">
        {cards.map((card, index) => (
          <div key={index} className="group relative bg-white rounded-3xl p-10 shadow-xl hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 border border-gray-100/50 overflow-hidden">
            {/* Gradient overlay */}
            <div className={`absolute inset-0 ${card.gradientOverlay} opacity-50 group-hover:opacity-70 transition-opacity duration-500`}></div>
            
            {/* Decorative elements */}
            <div className={`absolute top-0 ${index % 2 === 0 ? 'right-0' : 'left-0'} w-32 h-32 ${card.decorativeGradient} rounded-full blur-2xl`}></div>
            <div className={`absolute -bottom-4 ${index % 2 === 0 ? '-left-4' : '-right-4'} w-24 h-24 ${card.bottomDecorative} rounded-full`}></div>
            
            <div className="relative z-10">
              <div className="flex items-center gap-4 mb-8">
                <div className={`p-4 ${card.iconGradient} rounded-2xl shadow-lg group-hover:scale-110 transition-transform duration-300`}>
                  {card.icon}
                </div>
                <h3 className={`text-3xl font-bold text-gray-900 ${card.titleHover} transition-colors`}>
                  {card.title}
                </h3>
              </div>
              
              <div className="space-y-5">
                {card.features.map((feature, featureIndex) => (
                  <div key={featureIndex} className="flex items-center space-x-4 group/item hover:translate-x-2 transition-transform duration-300">
                    <div className="p-2 bg-green-100 rounded-full group-hover/item:bg-green-200 transition-colors">
                      <CheckCircle className="w-5 h-5 text-green-600" />
                    </div>
                    <div className="flex items-center space-x-3 flex-1">
                      <div className={`${card.featureIconColor} opacity-70 group-hover/item:opacity-100 transition-opacity`}>
                        {feature.icon}
                      </div>
                      <span className="text-gray-700 font-medium group-hover/item:text-gray-900 transition-colors">
                        {feature.text}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
              
              <div className="mt-8 pt-6 border-t border-gray-200/50">
                <div className="flex items-center justify-between">
                  <span className="text-sm text-gray-500">{card.categoryLabel}</span>
                  <div className="flex space-x-1">
                    <div className={`w-2 h-2 ${card.pulseColors[0]} rounded-full animate-pulse`}></div>
                    <div className={`w-2 h-2 ${card.pulseColors[1]} rounded-full animate-pulse`} style={{animationDelay: '0.5s'}}></div>
                    <div className={`w-2 h-2 ${card.pulseColors[2]} rounded-full animate-pulse`} style={{animationDelay: '1s'}}></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
       
    </div>
  </section>
);

export default function Landing() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [formData, setFormData] = useState({
    fullName: '',
    phoneNumber: '',
    email: '',
    companyName: '',
    message: ''
  });
  const [isVisible, setIsVisible] = useState(false);
  const [currentFeature, setCurrentFeature] = useState(0);

  useEffect(() => {
    setIsVisible(true);
    const interval = setInterval(() => {
      setCurrentFeature((prev) => (prev + 1) % 4);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Demo request submitted! We will contact you soon.');
    setFormData({
      fullName: '',
      phoneNumber: '',
      email: '',
      companyName: '',
      message: ''
    });
  };

  // Card data configurations
  const paymentGatewayCards = [
    {
      icon: <Zap className="w-8 h-8 text-white" />,
      title: "Payin",
      gradientOverlay: "bg-gradient-to-br from-blue-50 via-blue-100/50 to-purple-50",
      decorativeGradient: "bg-gradient-to-br from-blue-400/20 to-purple-400/20",
      bottomDecorative: "bg-gradient-to-tr from-blue-500/10 to-purple-500/10",
      iconGradient: "bg-gradient-to-r from-blue-500 to-blue-600",
      titleHover: "group-hover:text-blue-800",
      featureIconColor: "text-blue-600",
      categoryLabel: "Transaction Features",
      pulseColors: ["bg-blue-400", "bg-purple-400", "bg-green-400"],
      features: [
        { text: "Create UPI ID in 1 Click", icon: <MousePointer className="w-5 h-5" /> },
        { text: "Send & Receive Payments Instantly", icon: <ArrowLeftRight className="w-5 h-5" /> },
        { text: "UPI Powered RuPay Cards", icon: <CreditCard className="w-5 h-5" /> },
        { text: "Easy to Use Mobile App", icon: <Smartphone className="w-5 h-5" /> },
        { text: "Real-time Transaction Updates", icon: <Bell className="w-5 h-5" /> }
      ]
    },
    {
      icon: <Shield className="w-8 h-8 text-white" />,
      title: "Payout",
      gradientOverlay: "bg-gradient-to-br from-purple-50 via-indigo-50 to-blue-50",
      decorativeGradient: "bg-gradient-to-br from-purple-400/20 to-indigo-400/20",
      bottomDecorative: "bg-gradient-to-tl from-purple-500/10 to-indigo-500/10",
      iconGradient: "bg-gradient-to-r from-purple-500 to-indigo-600",
      titleHover: "group-hover:text-purple-800",
      featureIconColor: "text-purple-600",
      categoryLabel: "Management Features",
      pulseColors: ["bg-purple-400", "bg-indigo-400", "bg-blue-400"],
      features: [
        { text: "Ensure Complete Security", icon: <Lock className="w-5 h-5" /> },
        { text: "Separate Business & Personal Expenses", icon: <Building2 className="w-5 h-5" /> },
        { text: "Real Time Tracking & Monitoring", icon: <Activity className="w-5 h-5" /> },
        { text: "Powerful Dashboard for 100% Visibility", icon: <BarChart3 className="w-5 h-5" /> },
        { text: "Advanced Analytics & Reports", icon: <TrendingUp className="w-5 h-5" /> }
      ]
    }
  ];

  const acquirerIssuerCards = [
    {
      icon: <Database className="w-8 h-8 text-white" />,
      title: "Acquirer",
      gradientOverlay: "bg-gradient-to-br from-green-50 via-emerald-50 to-teal-50",
      decorativeGradient: "bg-gradient-to-br from-green-400/20 to-emerald-400/20",
      bottomDecorative: "bg-gradient-to-tr from-green-500/10 to-emerald-500/10",
      iconGradient: "bg-gradient-to-r from-green-500 to-emerald-600",
      titleHover: "group-hover:text-green-800",
      featureIconColor: "text-green-600",
      categoryLabel: "Acquiring Features",
      pulseColors: ["bg-green-400", "bg-emerald-400", "bg-teal-400"],
      features: [
        { text: "Multi-Channel Payment Processing", icon: <CreditCard className="w-5 h-5" /> },
        { text: "Advanced Fraud Detection", icon: <Shield className="w-5 h-5" /> },
        { text: "Real-time Authorization", icon: <Zap className="w-5 h-5" /> },
        { text: "Merchant Risk Management", icon: <Activity className="w-5 h-5" /> },
        { text: "Settlement & Reconciliation", icon: <BarChart3 className="w-5 h-5" /> }
      ]
    },
    {
      icon: <Cpu className="w-8 h-8 text-white" />,
      title: "Issuer",
      gradientOverlay: "bg-gradient-to-br from-orange-50 via-amber-50 to-yellow-50",
      decorativeGradient: "bg-gradient-to-br from-orange-400/20 to-amber-400/20",
      bottomDecorative: "bg-gradient-to-tl from-orange-500/10 to-amber-500/10",
      iconGradient: "bg-gradient-to-r from-orange-500 to-amber-600",
      titleHover: "group-hover:text-orange-800",
      featureIconColor: "text-orange-600",
      categoryLabel: "Issuing Features",
      pulseColors: ["bg-orange-400", "bg-amber-400", "bg-yellow-400"],
      features: [
        { text: "Card Lifecycle Management", icon: <CreditCard className="w-5 h-5" /> },
        { text: "Authorization & Clearing", icon: <CheckCircle className="w-5 h-5" /> },
        { text: "Cardholder Authentication", icon: <Lock className="w-5 h-5" /> },
        { text: "Spending Controls & Limits", icon: <Settings className="w-5 h-5" /> },
        { text: "Transaction Monitoring", icon: <Activity className="w-5 h-5" /> }
      ]
    }
  ];

  const videoManagementCards = [
    {
      icon: <Video className="w-8 h-8 text-white" />,
      title: "Video Call Management",
      gradientOverlay: "bg-gradient-to-br from-cyan-50 via-sky-50 to-blue-50",
      decorativeGradient: "bg-gradient-to-br from-cyan-400/20 to-sky-400/20",
      bottomDecorative: "bg-gradient-to-tr from-cyan-500/10 to-sky-500/10",
      iconGradient: "bg-gradient-to-r from-cyan-500 to-sky-600",
      titleHover: "group-hover:text-cyan-800",
      featureIconColor: "text-cyan-600",
      categoryLabel: "Video Call Features",
      pulseColors: ["bg-cyan-400", "bg-sky-400", "bg-blue-400"],
      features: [
        { text: "HD Video Quality", icon: <Video className="w-5 h-5" /> },
        { text: "Multi-party Conference Calls", icon: <Users className="w-5 h-5" /> },
        { text: "Screen Sharing & Recording", icon: <FileText className="w-5 h-5" /> },
        { text: "Real-time Chat Integration", icon: <Bell className="w-5 h-5" /> },
        { text: "Meeting Scheduling & Management", icon: <Clock className="w-5 h-5" /> }
      ]
    },
    {
      icon: <Eye className="w-8 h-8 text-white" />,
      title: "VideoKYC",
      gradientOverlay: "bg-gradient-to-br from-rose-50 via-pink-50 to-purple-50",
      decorativeGradient: "bg-gradient-to-br from-rose-400/20 to-pink-400/20",
      bottomDecorative: "bg-gradient-to-tl from-rose-500/10 to-pink-500/10",
      iconGradient: "bg-gradient-to-r from-rose-500 to-pink-600",
      titleHover: "group-hover:text-rose-800",
      featureIconColor: "text-rose-600",
      categoryLabel: "KYC Features",
      pulseColors: ["bg-rose-400", "bg-pink-400", "bg-purple-400"],
      features: [
        { text: "Biometric Verification", icon: <Eye className="w-5 h-5" /> },
        { text: "Document Authentication", icon: <FileText className="w-5 h-5" /> },
        { text: "Live Face Detection", icon: <Shield className="w-5 h-5" /> },
        { text: "AI-Powered Identity Checks", icon: <Cpu className="w-5 h-5" /> },
        { text: "Compliance & Audit Trail", icon: <Lock className="w-5 h-5" /> }
      ]
    }
  ];
  const ecommerceSolutionsCards = [
    {
      icon: <ShoppingCart className="w-8 h-8 text-white" />,
      title: "Ecommerce Integration",
      gradientOverlay: "bg-gradient-to-br from-green-50 via-teal-50 to-cyan-50",
      decorativeGradient: "bg-gradient-to-br from-green-400/20 to-teal-400/20",
      bottomDecorative: "bg-gradient-to-tl from-green-500/10 to-teal-500/10",
      iconGradient: "bg-gradient-to-r from-green-500 to-teal-600",
      titleHover: "group-hover:text-green-800",
      featureIconColor: "text-green-600",
      categoryLabel: "Ecommerce Features",
      pulseColors: ["bg-green-400", "bg-teal-400", "bg-cyan-400"],
      features: [
        { text: "Seamless Checkout Experience", icon: <ShoppingCart className="w-5 h-5" /> },
        { text: "Multi-Currency Support", icon: <Globe className="w-5 h-5" /> },
        { text: "Fraud Prevention Tools", icon: <Shield className="w-5 h-5" /> },
        { text: "Customizable Payment Flows", icon: <Settings className="w-5 h-5" /> },
        { text: "Analytics & Reporting", icon: <BarChart className="w-5 h-5" /> }
      ]
    }
  ];

  const dataInsightsCards = [
    {
      icon: <Database className="w-8 h-8 text-white" />,
      title: "Data Analytics",
      gradientOverlay: "bg-gradient-to-br from-yellow-50 via-amber-50 to-orange-50",
      decorativeGradient: "bg-gradient-to-br from-yellow-400/20 to-amber-400/20",
      bottomDecorative: "bg-gradient-to-tl from-yellow-500/10 to-amber-500/10",
      iconGradient: "bg-gradient-to-r from-yellow-500 to-amber-600",
      titleHover: "group-hover:text-yellow-800",
      featureIconColor: "text-yellow-600",
      categoryLabel: "Data Insights Features",
      pulseColors: ["bg-yellow-400", "bg-amber-400", "bg-orange-400"],
      features: [
        { text: "Real-time Analytics Dashboard", icon: <Database className="w-5 h-5" /> },
        { text: "Custom Reporting Tools", icon: <FileText className="w-5 h-5" /> },
        { text: "Data Visualization Solutions", icon: <BarChart className="w-5 h-5" /> },
        { text: "Predictive Analytics", icon: <Cpu className="w-5 h-5" /> },
        { text: "Data Integration Services", icon: <Settings className="w-5 h-5" /> }
      ]
    }
  ];
  const crmSolutionsCards = [
    {
      icon: <Users className="w-8 h-8 text-white" />,
      title: "CRM Solutions",
      gradientOverlay: "bg-gradient-to-br from-purple-50 via-violet-50 to-indigo-50",
      decorativeGradient: "bg-gradient-to-br from-purple-400/20 to-violet-400/20",
      bottomDecorative: "bg-gradient-to-tl from-purple-500/10 to-violet-500/10",
      iconGradient: "bg-gradient-to-r from-purple-500 to-violet-600",
      titleHover: "group-hover:text-purple-800",
      featureIconColor: "text-purple-600",
      categoryLabel: "CRM Features",
      pulseColors: ["bg-purple-400", "bg-violet-400", "bg-indigo-400"],
      features: [
        { text: "Customer Relationship Management", icon: <Users className="w-5 h-5" /> },
        { text: "Lead Management", icon: <ArrowRight className="w-5 h-5" /> },
        { text: "Sales Automation", icon: <TrendingUp className="w-5 h-5" /> },
        { text: "Email Marketing Integration", icon: <Mail className="w-5 h-5" /> },
        { text: "Customer Support Tools", icon: <Bell className="w-5 h-5" /> }
      ]
    }
  ];
  const bankingFinanceCards = [
    {
      icon: <Wifi className="w-8 h-8 text-white" />,
      title: "Banking & Finance Solutions",
      gradientOverlay: "bg-gradient-to-br from-teal-50 via-cyan-50 to-blue-50",
      decorativeGradient: "bg-gradient-to-br from-teal-400/20 to-cyan-400/20",
      bottomDecorative: "bg-gradient-to-tl from-teal-500/10 to-cyan-500/10",
      iconGradient: "bg-gradient-to-r from-teal-500 to-cyan-600",
      titleHover: "group-hover:text-teal-800",
      featureIconColor: "text-teal-600",
      categoryLabel: "Banking Features",
      pulseColors: ["bg-teal-400", "bg-cyan-400", "bg-blue-400"],
      features: [
        { text: "Account Management", icon: <Users className="w-5 h-5" /> },
        { text: "Transaction Monitoring", icon: <Eye className="w-5 h-5" /> },
        { text: "Fraud Detection", icon: <Shield className="w-5 h-5" /> },
        { text: "Regulatory Compliance", icon: <Lock className="w-5 h-5" /> },
        { text: "Risk Assessment", icon: <ChartBar className="w-5 h-5" /> }
      ]
    }
  ];


  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
         <Header />

      {/* Hero Section */}
         <section className="bg-gradient-to-br from-blue-50 to-indigo-100 py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h1 className="text-5xl font-bold text-gray-900 mb-6">
                Seamless Payment
                <br />
                Solutions
              </h1>
              <p className="text-xl text-gray-600 mb-8">
                Elevate Your Business with Our Cutting-Edge Payment Gateway Services for Secure and Effortless Transactions
              </p>
              <button className="bg-blue-600 text-white px-8 py-4 rounded-full text-lg font-medium hover:bg-blue-700 transition-colors shadow-lg">
                START AN ACCOUNT
              </button>
            </div>
            <div className="relative">
              <div className="bg-white rounded-2xl shadow-2xl p-8 transform rotate-3 hover:rotate-0 transition-transform duration-300">
                <div className="bg-gray-900 rounded-lg p-4 mb-4">
                  <div className="flex items-center space-x-2">
                    <div className="w-3 h-3 bg-red-500 rounded-full"></div>
                    <div className="w-3 h-3 bg-yellow-500 rounded-full"></div>
                    <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                  </div>
                  <div className="mt-4 space-y-2">
                    <div className="h-2 bg-blue-400 rounded w-3/4"></div>
                    <div className="h-2 bg-green-400 rounded w-1/2"></div>
                    <div className="h-2 bg-purple-400 rounded w-5/6"></div>
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-4">
                  <div className="bg-blue-100 p-4 rounded-lg">
                    <div className="w-8 h-8 bg-blue-600 rounded-full mb-2"></div>
                    <div className="h-2 bg-blue-300 rounded w-full mb-1"></div>
                    <div className="h-2 bg-blue-300 rounded w-3/4"></div>
                  </div>
                  <div className="bg-green-100 p-4 rounded-lg">
                    <div className="w-8 h-8 bg-green-600 rounded-full mb-2"></div>
                    <div className="h-2 bg-green-300 rounded w-full mb-1"></div>
                    <div className="h-2 bg-green-300 rounded w-3/4"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Journey Numbers */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">OUR JOURNEY IN NUMBERS</h2>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="text-4xl font-bold text-blue-600 mb-2">2M+</div>
              <div className="text-gray-600">Users Trust</div>
              <div className="text-gray-600">Globally</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-blue-600 mb-2">9.5</div>
              <div className="text-gray-600">Lakhs+ Cards</div>
              <div className="text-gray-600">Onboard</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-blue-600 mb-2">₹108</div>
              <div className="text-gray-600">Crore with monthly</div>
              <div className="text-gray-600">Transactions</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-blue-600 mb-2">2.8</div>
              <div className="text-gray-600">Crore Transactions</div>
              <div className="text-gray-600">Processed Annually</div>
            </div>
          </div>
        </div>
      </section>

      {/* Payment Gateway Solutions */}
      <CardSection 
        title="Payment Gateway Solutions"
        cards={paymentGatewayCards} 
      />

      {/* Acquirer & Issuer Solutions */}
      <CardSection 
        title="NETC Solutions"
        cards={acquirerIssuerCards} 
      />

      {/* Video Management Solutions */}
      <CardSection 
        title="Video Management Solutions"
        cards={videoManagementCards} 
      /> 
      {/* Ecommerce Solutions */}
      <CardSection 
        title="Ecommerce Solutions"
        cards={ecommerceSolutionsCards} 
      />

      {/* Data Insights & BI Solutions */}
      <CardSection 
        title="Unlocking Data Insights"
        cards={dataInsightsCards} 
      />

      {/* CRM Solutions */}
      <CardSection 
        title="CRM Custom Built Solutions"
        cards={crmSolutionsCards} 
      />

      {/* Banking & Finance Tech */}
      <CardSection 
        title="Banking & Finance Tech"
        cards={bankingFinanceCards} 
      />
      {/* Flexible Features */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">SCALE YOUR BUSINESS WITH FLEXIBLE FEATURES</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-5 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Zap className="h-8 w-8 text-red-600" />
              </div>
              <div className="font-semibold text-gray-900 mb-2">Ready-To-Use APIs</div>
              <div className="text-sm text-gray-600">Quick integration</div>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-gray-800 rounded-full flex items-center justify-center mx-auto mb-4">
                <CheckCircle className="h-8 w-8 text-white" />
              </div>
              <div className="font-semibold text-gray-900 mb-2">100% Customizable</div>
              <div className="text-sm text-gray-600">Tailored solutions</div>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Globe className="h-8 w-8 text-red-600" />
              </div>
              <div className="font-semibold text-gray-900 mb-2">Easy Integration</div>
              <div className="text-sm text-gray-600">Simple setup</div>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-gray-800 rounded-full flex items-center justify-center mx-auto mb-4">
                <Users className="h-8 w-8 text-white" />
              </div>
              <div className="font-semibold text-gray-900 mb-2">Exhaustive Tech Stack</div>
              <div className="text-sm text-gray-600">Complete solutions</div>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Shield className="h-8 w-8 text-red-600" />
              </div>
              <div className="font-semibold text-gray-900 mb-2">Minimal Transaction</div>
              <div className="text-sm text-gray-600">Cost effective</div>
            </div>
          </div>
        </div>
      </section>

      {/* Implementation Process */}
         <section className="py-16 bg-gray-50">
              <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-12">
                  <h2 className="text-3xl font-bold text-gray-900 mb-4">
                    Staff Augmentation
                  </h2>
                </div>
                
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                  <div className="bg-white rounded-2xl p-8 text-center shadow-lg">
                    <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-6">
                      <Zap className="w-8 h-8 text-orange-500" />
                    </div>
                    <h3 className="text-xl font-bold mb-4">Staff Augmentation</h3>
                    <p className="text-gray-600">

                      Managing the cutting edge projects and collaborating as your team.

                    </p>
                  </div>
      
                  <div className="bg-white rounded-2xl p-8 text-center shadow-lg">
                    <div className="w-16 h-16 bg-pink-100 rounded-full flex items-center justify-center mx-auto mb-6">
                      <Clock className="w-8 h-8 text-pink-500" />
                    </div>
                    <h3 className="text-xl font-bold mb-4">Outsourcing</h3>
                    <p className="text-gray-600">
                      Outsourcing your projects to our team of experts, ensuring timely delivery and quality.
                    </p>
                  </div>
      
                  <div className="bg-white rounded-2xl p-8 text-center shadow-lg">
                    <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
                      <Shield className="w-8 h-8 text-green-500" />
                    </div>
                    <h3 className="text-xl font-bold mb-4">Managed Services	</h3>
                    <p className="text-gray-600">
                      Vendor based managed services for your business, with a focus on quality and efficiency.
                    </p>
                  </div>
                </div>
              </div>
            </section>



      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Staff Augmentation</h2>
            {/* <p className="text-gray-600">GO LIVE IN JUST ONE MONTH</p> */}
          </div>
          
          <div className="grid md:grid-cols-3 gap-8 mb-12">
            <div className="text-center">
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <span className="text-2xl font-bold text-red-600">1</span>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Payin</h3>
              <p className="text-gray-600">Hands-on consultation from our business development experts for effortless setup and seamlessly integrate it with your existing workflows.</p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <span className="text-2xl font-bold text-red-600">2</span>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Payout</h3>
              <p className="text-gray-600">The best and refined understanding of your business along with our technical consultants' mind is central to the solution being developed then upgraded to life testing.</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <span className="text-2xl font-bold text-red-600">2</span>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Payout</h3>
              <p className="text-gray-600">The best and refined understanding of your business along with our technical consultants' mind is central to the solution being developed then upgraded to life testing.</p>
            </div>
       
          </div>
          
          
        </div>
      </section>

      {/* Enterprise Clients */}
  <section className="py-20 bg-gradient-to-br from-gray-50 to-blue-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              Trusted by Industry Leaders
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              See what our clients say about their payout experience
            </p>
          </div>

          <div className="grid lg:grid-cols-3 gap-8">
            {[
              {
                name: "Rahul Sharma",
                position: "CFO, TechCorp",
                company: "TechCorp Solutions",
                rating: 5,
                comment: "Our payout processing time reduced from hours to minutes. The reliability is outstanding!",
                avatar: "RS",
                color: "bg-blue-500"
              },
              {
                name: "Priya Patel",
                position: "Finance Head",
                company: "Digital Ventures",
                rating: 5,
                comment: "The bulk processing feature handles our 10,000+ monthly payouts seamlessly. Game changer!",
                avatar: "PP",
                color: "bg-purple-500"
              },
              {
                name: "Amit Kumar",
                position: "Operations Manager",
                company: "StartupXYZ",
                rating: 5,
                comment: "24/7 support and 99.8% success rate. Couldn't ask for more from a payout solution.",
                avatar: "AK",
                color: "bg-green-500"
              }
            ].map((testimonial, index) => (
              <div key={index} className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border border-gray-100">
                <div className="space-y-6">
                  {/* Stars */}
                  <div className="flex gap-1">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <Star key={i} className="w-5 h-5 text-yellow-500 fill-current" />
                    ))}
                  </div>

                  {/* Comment */}
                  <p className="text-gray-600 leading-relaxed italic">
                    "{testimonial.comment}"
                  </p>

                  {/* Profile */}
                  <div className="flex items-center gap-4">
                    <div className={`w-12 h-12 ${testimonial.color} rounded-full flex items-center justify-center text-white font-bold`}>
                      {testimonial.avatar}
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900">{testimonial.name}</h4>
                      <p className="text-sm text-gray-500">{testimonial.position}</p>
                      <p className="text-sm text-gray-400">{testimonial.company}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
       <CompanyLogosMarquee />

         <section className="py-20 bg-gradient-to-r from-blue-600 to-purple-600">
        <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
            Ready to Transform Your Payouts?
          </h2>
          <p className="text-xl text-blue-100 mb-8">
            Join thousands of businesses already using our platform
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button className="inline-flex items-center justify-center gap-2 bg-white text-blue-600 px-8 py-4 rounded-xl font-semibold hover:shadow-lg transition-all duration-300 hover:scale-105">
              <Play className="w-5 h-5" />
              Get Started Now
            </button>
            <button className="inline-flex items-center justify-center gap-2 border-2 border-white text-white px-8 py-4 rounded-xl font-semibold hover:bg-white hover:text-blue-600 transition-all duration-300">
              <CreditCard className="w-5 h-5" />
              Schedule Demo
            </button>
          </div>
        </div>
      </section>
     {/* <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
           
          <div className="text-center">
            <div className="inline-flex space-x-4">
              <button className="bg-blue-600 text-white px-8 py-3 rounded-full font-medium hover:bg-blue-700 transition-colors">
                Get Started with us
              </button>
            </div>
          </div>
        </div>
      </section> */}
      {/* Footer */}
          <Footer />
    </div>
  )
}